const styles = (theme) => ({
  loaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: "column",
    marginBottom: 12
  },
  editFlowWarningMessage: {
    marginBottom: 12
  },
  loader: {
    alignSelf: 'center',
    marginRight: 20
  },
  noCustomer: {
    color: theme.ModalHeaderTextColor
  },
  messageContainer: {
    marginTop: 14,
  }
});

export default styles;
